export const DEMO_MODE = true;

export const WHATSAPP_URL = "https://maapp.com.br/daniellysousanails";
export const PRIMARY_CTA_URL = WHATSAPP_URL;

export const business = {
    name: "Studio Danielly Sousa",
    shortName: "SDS",
    segment: "Nail Designer",
    city: "Uruaçu",
    state: "GO",
    whatsapp: WHATSAPP_URL,
    instagram: "https://www.instagram.com/studiodaniellysnails/",
    maps: "https://www.google.com/maps/place/Danielly+Nails/@-14.5216499,-49.1444578,994m/data=!3m1!1e3!4m15!1m8!3m7!1s0x934309fe7dd3e0ff:0x5e727f0cc54cfca9!2sDanielly+Nails!8m2!3d-14.5216499!4d-49.1444578!10e5!16s%2Fg%2F11jh77y2bw!3m5!1s0x934309fe7dd3e0ff:0x5e727f0cc54cfca9!8m2!3d-14.5216499!4d-49.1444578!16s%2Fg%2F11jh77y2bw",
    mapsEmbed: "https://maps.google.com/maps?q=-14.5216499,-49.1444578&z=16&output=embed",
    directions:
        "https://www.google.com/maps/dir/?api=1&destination=-14.5216499%2C-49.1444578",
};

const base = "/img";

export const images = {
    portrait: `${base}/danielly-portrait.webp`,
    nailsPink: `${base}/nails-pink.webp`,
    nailsChrome: `${base}/nails-chrome.webp`,
    course: `${base}/course-teaching.webp`,
    break: `${base}/break-nails.webp`,
};

export const heroNailDetail = `${base}/nails-chrome.webp`;

export const firstWorks = [
    {
        url: `${base}/nails-pink.webp`,
        tag: "TRABALHO REAL",
        ratio: "aspect-[1/1]",
        title: "Acabamento em rosa com brilho",
    },
    {
        url: `${base}/nails-chrome.webp`,
        tag: "TRABALHO REAL",
        ratio: "aspect-[4/3]",
        title: "Acabamento cromado perolado",
    },
];

export const gallery = [
    {
        url: `${base}/nails-pink.webp`,
        title: "Trabalho real — Studio Danielly Sousa",
        category: "Alongamento",
        ratio: "aspect-square",
    },
    {
        url: `${base}/nails-chrome.webp`,
        title: "Trabalho real — Studio Danielly Sousa",
        category: "Molde F1",
        ratio: "aspect-[4/3]",
    },
];

export const services = [
    {
        title: "Alongamento e fibra de vidro",
        description:
            "Descrição breve apresentando o principal benefício deste serviço.",
        photo: `${base}/nails-pink.webp`,
    },
    {
        title: "Molde F1",
        description:
            "Descrição breve apresentando o principal benefício deste serviço.",
        photo: `${base}/nails-chrome.webp`,
    },
    {
        title: "Banho de gel",
        description:
            "Descrição breve apresentando o principal benefício deste serviço.",
        photo: "/img/banho-gel.webp",
    },
    {
        title: "Blindagem",
        description:
            "Descrição breve apresentando o principal benefício deste serviço.",
        photo: "/img/service-blindagem.webp",
    },
    {
        title: "Esmaltação em gel",
        description:
            "Descrição breve apresentando o principal benefício deste serviço.",
        photo: "/img/nails-black.webp",
    },
];

export const aboutHighlights = [
    "DESDE 2015 NA ÁREA",
    "NAIL DESIGNER",
    "INSTRUTORA",
    "URUAÇU - GO",
];

export const differentials = [
    {
        title: "ATENDIMENTO PERSONALIZADO",
        desc: "Uma experiência construída de acordo com as necessidades de cada cliente.",
    },
    {
        title: "QUALIDADE",
        desc: "Cuidado em cada etapa do atendimento.",
    },
    {
        title: "AGILIDADE",
        desc: "Comunicação simples e objetiva.",
    },
    {
        title: "EXPERIÊNCIA",
        desc: "Uma jornada pensada do primeiro contato ao pós-atendimento.",
    },
];

export const steps = [
    { n: "01", title: "ENTRE EM CONTATO" },
    { n: "02", title: "CONVERSE COM NOSSA EQUIPE" },
    { n: "03", title: "ESCOLHA A MELHOR SOLUÇÃO" },
    { n: "04", title: "RECEBA SEU ATENDIMENTO" },
];

export const faqs = [
    {
        q: "Como funciona o atendimento?",
        a: "O atendimento começa com uma conversa para entender o que você procura. A partir daí, a Danielly indica o serviço ideal para as suas unhas e o resultado desejado.",
    },
    {
        q: "Como faço para agendar um horário?",
        a: "É só chamar no WhatsApp. Você recebe as opções de horários disponíveis e escolhe a melhor data para você.",
    },
    {
        q: "Vocês atendem pelo WhatsApp?",
        a: "Sim. O WhatsApp é o canal principal do Studio, rápido e direto, para agendamentos e dúvidas.",
    },
    {
        q: "Onde o Studio está localizado?",
        a: "O Studio Danielly Sousa fica em Uruaçu – GO. No mapa abaixo você encontra a localização exata para o seu agendamento.",
    },
    {
        q: "Quais serviços o Studio oferece?",
        a: "Alongamento e fibra de vidro, Molde F1, banho de gel, blindagem e esmaltação em gel — sempre com avaliação cuidadosa antes de cada procedimento.",
    },
];

export const navItems = [
    { label: "Início", href: "#inicio" },
    { label: "Trabalhos", href: "#trabalhos" },
    { label: "Sobre", href: "#sobre" },
    { label: "Serviços", href: "#servicos" },
    { label: "Resultados", href: "#resultados" },
    { label: "Avaliações", href: "#avaliacoes" },
    { label: "Localização", href: "#localizacao" },
];
